<template>
  <div>
    <component :is="currentComponent" @input="currentModal = ''" />

    <smart-tooltip
      :link="helpLink"
      hide-activator
      :category="helpCategory"
      :type="helpType"
      ref="smartTooltip"
    />
  </div>
</template>

<script>
import capitalize from 'lodash/capitalize';
import SmartTooltip from '@/components/basic/smart-tooltip/SmartTooltip';
import EventBus from '@/factories/eventBus';

export default {
  name: 'HelpModal',
  components: { SmartTooltip },
  data() {
    return {
      currentModal: '',
      helpCategory: '',
      helpType: '',
      helpLink: false,
    };
  },
  computed: {
    currentComponent() {
      if (!this.currentModal) return;

      return () => import(`./${this.currentModal}`);
    },
  },
  methods: {
    showTooltip({ category, type, link, event }) {
      this.helpCategory = category;
      this.helpType = type;
      this.helpLink = !!link;
      this.$nextTick(() => {
        this.$refs.smartTooltip?.customShow(event);
      });
    },
    checkHelpLinkClick(e) {
      const link = e.target.closest('.help-link');
      if (!link) return;

      let helpRoute = link.getAttribute('data-route') || '';
      let helpCategory = link.getAttribute('data-category') || '';
      if (helpRoute.startsWith('help')) {
        e.stopPropagation();
        e.preventDefault();

        if (helpRoute.startsWith('help/modal')) {
          return this.initHelpModal(helpRoute);
        }

        if (helpCategory) {
          this.showTooltip({
            category: helpCategory,
            type: helpRoute,
            link: true,
            event: e,
          });
          return;
        }

        const path = `https://conveyour.com/${helpRoute}`;
        window.open(path, '_blank');
      }
    },
    initHelpModal(path) {
      let helpComponent = path.split('-').reduce((acc, item) => {
        if (!item.startsWith('help')) {
          acc += capitalize(item);
        }
        return acc;
      }, '');

      if (!this.isComponentValid(helpComponent)) return;
      this.currentModal = helpComponent;
    },
    isComponentValid(component) {
      const helpModals = ['DelayTimeInfo'];
      return helpModals.includes(component);
    },
    toggleClickListener(listen = false) {
      let method = listen ? 'addEventListener' : 'removeEventListener';
      window[method]('click', this.checkHelpLinkClick);
    },
  },
  created() {
    this.toggleClickListener(true);
    EventBus.$on('showSmartTooltip', this.showTooltip);
  },
  beforeDestroy() {
    this.toggleClickListener();
    EventBus.$off('showSmartTooltip', this.showTooltip);
  },
};
</script>
